export default "__VITE_ASSET__CmpOSP5k__"